import { Link } from "react-router-dom";

const footerLinks = [
  { path: "/", label: "首页" },
  { path: "/category/yule-bagua", label: "娱乐八卦" },
  { path: "/category/mingxing-heiliao", label: "明星黑料" },
  { path: "/category/wanghong-fancha", label: "网红反差" },
  { path: "/category/meiri-dasai", label: "每日大赛" },
  { path: "/about", label: "关于我们" },
];

const socialLinks = [
  { icon: "ri-weibo-line", label: "微博", href: "#" },
  { icon: "ri-wechat-line", label: "微信", href: "#" },
  { icon: "ri-tiktok-line", label: "抖音", href: "#" },
  { icon: "ri-red-packet-line", label: "小红书", href: "#" },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-10 py-14 md:py-16">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-0">
          <div className="lg:w-1/3">
            <h3 className="text-3xl md:text-4xl font-bold font-heading mb-8">
              黑料吃瓜网
            </h3>
            <p className="text-sm text-foreground-100 leading-relaxed max-w-xs">
              24小时不打烊的吃瓜第一线。聚合全网黑料大全、网红八卦与明星黑料，做吃瓜群众最信赖的娱乐资讯平台。
            </p>
            <div className="flex gap-4 mt-8">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  className="w-10 h-10 rounded-full border border-foreground-300 flex items-center justify-center cursor-pointer hover:bg-background-50 hover:text-foreground-950 transition-colors duration-200"
                  aria-label={social.label}
                  rel="nofollow"
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="lg:w-1/3 flex flex-col gap-6">
            <div>
              <h4 className="text-xs font-semibold tracking-widest text-foreground-200 uppercase mb-2">
                ADDRESS
              </h4>
              <p className="text-sm text-foreground-100">
                北京市朝阳区建国路88号<br />SOHO现代城A座1208室
              </p>
            </div>
            <div>
              <h4 className="text-xs font-semibold tracking-widest text-foreground-200 uppercase mb-2">
                PHONE
              </h4>
              <p className="text-sm text-foreground-100">+86 400-000-0000</p>
            </div>
            <div>
              <h4 className="text-xs font-semibold tracking-widest text-foreground-200 uppercase mb-2">
                EMAIL
              </h4>
              <p className="text-sm text-foreground-100">hello@cgiqwhk.cn</p>
            </div>
          </div>

          <div className="lg:w-1/3 flex lg:justify-end">
            <div className="w-48 h-64 rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20trendy%20office%20space%20with%20creative%20design%2C%20neon%20signs%2C%20young%20team%20working%20on%20laptops%2C%20urban%20loft%20style%2C%20warm%20ambient%20lighting%2C%20editorial%20photography%2C%20stylish%20interior%20with%20plants%20and%20industrial%20elements&width=400&height=533&seq=footer-office&orientation=portrait"
                alt="黑料吃瓜网办公环境"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-foreground-700/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-300">
            &copy; 2024-2026 黑料吃瓜网 版权所有
          </p>
          <div className="flex gap-6">
            <Link to="/about" className="text-xs text-foreground-300 hover:text-foreground-100 whitespace-nowrap cursor-pointer transition-colors duration-200">
              隐私政策
            </Link>
            <Link to="/about" className="text-xs text-foreground-300 hover:text-foreground-100 whitespace-nowrap cursor-pointer transition-colors duration-200">
              用户协议
            </Link>
            <Link to="/about" className="text-xs text-foreground-300 hover:text-foreground-100 whitespace-nowrap cursor-pointer transition-colors duration-200">
              联系我们
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}